package api.traak

enum class StorageResult {
  Success,
  FailureUnknown,
  FailurePermissionDenied,
}
